var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "app-user-side-menu",
        { attrs: { "min-width": 15, "fixed-menu": false } },
        [
          _c(
            "aside",
            {
              staticClass: "menu",
              attrs: { slot: "side-menu" },
              slot: "side-menu",
            },
            [
              _c("div", { staticClass: "menu-label" }, [
                _c("div", { staticClass: "columns is-gapless mb-2" }, [
                  _c("div", { staticClass: "column" }, [
                    _c(
                      "span",
                      {
                        staticClass: "title is-6",
                        staticStyle: { "white-space": "nowrap" },
                      },
                      [_vm._v(" Username: " + _vm._s(_vm.entityName) + " ")]
                    ),
                  ]),
                ]),
              ]),
              _c("ul", { staticClass: "menu-list" }, [
                _c(
                  "li",
                  [
                    _c(
                      "router-link",
                      {
                        class: {
                          "tooltip is-tooltip-danger is-tooltip-right":
                            _vm.$v.detailGroup.$error,
                        },
                        attrs: {
                          to: {
                            name: _vm.routeTypes.UserDetail.name,
                            params: { userId: _vm.$route.params.userId },
                          },
                          "active-class": "is-active",
                          "data-tooltip": [
                            _vm.$v.detailGroup.$error
                              ? "Validation errors"
                              : "",
                          ],
                          exact: "",
                        },
                      },
                      [
                        _c(
                          "span",
                          {
                            class: {
                              "has-badge-danger has-badge-small has-badge-rounded has-badge-offset2":
                                _vm.$v.detailGroup.$error,
                            },
                            attrs: {
                              "data-badge": _vm.$v.detailGroup.$error
                                ? ""
                                : null,
                            },
                          },
                          [_vm._v("Details ")]
                        ),
                      ]
                    ),
                  ],
                  1
                ),
                _c(
                  "li",
                  [
                    _c(
                      "router-link",
                      {
                        class: {
                          "tooltip is-tooltip-danger is-tooltip-right":
                            !_vm.validProfileGroup,
                        },
                        attrs: {
                          to: {
                            name: _vm.routeTypes.UserProfile.name,
                            params: { userId: _vm.$route.params.userId },
                          },
                          "active-class": "is-active",
                          "data-tooltip": [
                            !_vm.validProfileGroup ? "Validation errors" : "",
                          ],
                          exact: "",
                        },
                      },
                      [
                        _c(
                          "span",
                          {
                            class: {
                              "has-badge-danger has-badge-small has-badge-rounded has-badge-offset2":
                                !_vm.validProfileGroup,
                            },
                            attrs: {
                              "data-badge": !_vm.validProfileGroup ? "" : null,
                            },
                          },
                          [_vm._v("User Profile")]
                        ),
                      ]
                    ),
                  ],
                  1
                ),
                !_vm.isMobileAppUser
                  ? _c(
                      "li",
                      [
                        _c(
                          "router-link",
                          {
                            class: {
                              "tooltip is-tooltip-danger is-tooltip-right":
                                _vm.$v.userAccessControl.$error,
                            },
                            attrs: {
                              to: {
                                name: _vm.routeTypes.UserAccessControl.name,
                                params: { userId: _vm.$route.params.userId },
                              },
                              "active-class": "is-active",
                              "data-tooltip": [
                                _vm.$v.userAccessControl.$error
                                  ? "Validation errors"
                                  : "",
                              ],
                              exact: "",
                            },
                          },
                          [
                            _c(
                              "span",
                              {
                                class: {
                                  "has-badge-danger has-badge-small has-badge-rounded has-badge-offset2":
                                    _vm.$v.userAccessControl.$error,
                                },
                                attrs: {
                                  "data-badge": _vm.$v.userAccessControl.$error
                                    ? ""
                                    : null,
                                },
                              },
                              [_vm._v("Access Control")]
                            ),
                          ]
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
                !_vm.isMobileAppUser
                  ? _c(
                      "li",
                      [
                        _c(
                          "router-link",
                          {
                            attrs: {
                              to: {
                                name: _vm.routeTypes.UserAccessRestriction.name,
                                params: { userId: _vm.$route.params.userId },
                              },
                              "active-class": "is-active",
                              exact: "",
                            },
                          },
                          [
                            _c("span", [
                              _c(
                                "span",
                                { staticClass: "has-badge-child-offset2" },
                                [_vm._v("Access Restriction")]
                              ),
                            ]),
                          ]
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
              ]),
            ]
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }